import { render } from "./Informacion.vue?vue&type=template&id=d15431dc"
import script from "./Informacion.vue?vue&type=script&lang=js"
export * from "./Informacion.vue?vue&type=script&lang=js"
script.render = render

export default script